'use client';

import { Code } from '@/sanity.types';

interface DynamicStyleLoaderProps {
  css: Code;
}

const DynamicStyleLoader = ({ css }: DynamicStyleLoaderProps) => {
  // Only apply CSS if it exists
  if (!css || !css.code) {
    return null;
  }

  return <style dangerouslySetInnerHTML={{ __html: css.code }} />;
};

export default DynamicStyleLoader;
